import TreeView from "../../components/treeView/treeView";
import { useTreeView } from "../../context/treeViewContext";
import { TreeViewProvider } from "../../context/treeViewContext";
import { useEffect, useRef, useState } from "react";
import { db } from "../../config/firebaseConfig";
import { useNavigate } from "react-router-dom";
import { collection, getDocs, query, where } from "firebase/firestore";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSquarePlus, faPencil, faLeftLong, faRightLong } from '@fortawesome/free-solid-svg-icons';
import Gantt from "frappe-gantt";
import "./gantt.css";

// フィルターボタン定義
const utilityCollections = [
    { colorClass: "electric", displayName: "電気", filterKey: "electric" },
    { colorClass: "network", displayName: "ネットワーク", filterKey: "network" },
    { colorClass: "air", displayName: "給排気", filterKey: "air" },
    { colorClass: "water", displayName: "給排水", filterKey: "water" },
    { colorClass: "others", displayName: "その他", filterKey: "others" }
];

const dateCollections = [
    { colorClass: "date", displayName: "3日前", filterKey: "three-days-ago" },
    { colorClass: "date", displayName: "昨日", filterKey: "yesterday" },
    { colorClass: "date", displayName: "今日", filterKey: "today" },
    { colorClass: "date", displayName: "明日", filterKey: "tomorrow" },
    { colorClass: "date", displayName: "3日間", filterKey: "three-days" },
    { colorClass: "date", displayName: "7日間", filterKey: "seven-days" },
    { colorClass: "date", displayName: "14日間", filterKey: "fourteen-days" },
    { colorClass: "date", displayName: "全期間", filterKey: "all-days" }
];

const GanttContent = () => {
    const {
        selectedID,
        childIDList,
        selectedAndChildIDList,
        selectedNode,
        setSelectedNodeID
    } = useTreeView();

    const treeRef = useRef(null);
    const ganttRef = useRef(null);
    const navigate = useNavigate();

    const [isActionButtonDisabled, setIsActionButtonDisabled] = useState(true);
    const [tasks, setTasks] = useState([]);
    const [selectedFilters, setSelectedFilters] = useState({
        electric: true,
        air: true,
        water: true,
        network: true,
        others: true
    });
    const [selectedRow, setSelectedRow] = useState(null);
    const [selectedFilter, setSelectedFilter] = useState('all-days');
    const [filteredTasks, setFilteredTasks] = useState([]);
    const [completionStatus, setCompletionStatus] = useState("all"); // "all" | "completed" | "incomplete"
    const currentProjectID = localStorage.getItem("currentProjectID");


    useEffect(() => {
        console.log("✅ useEffect: selectedAndChildIDList 更新:", selectedAndChildIDList);
    }, [selectedAndChildIDList]);

    // fetch
    useEffect(() => {
        const fetchData = async () => {
            if (!selectedAndChildIDList || selectedAndChildIDList.length === 0) {
                setTasks([]);
                return;
            }

            const categories = ["electric", "air", "water", "network", "others"];
            const chunks = [];

            for (let i = 0; i < selectedAndChildIDList.length; i += 10) {
                chunks.push(selectedAndChildIDList.slice(i, i + 10));
            }

            const allTasks = [];

            for (const chunk of chunks) {
                try {
                    const q = query(
                        collection(db, "00_DeviceMasterTable"),
                        where("masterID", "in", chunk),
                        where("projectID", "==", currentProjectID)
                    );
                    const snapshot = await getDocs(q);

                    snapshot.docs.forEach((doc) => {
                        const item      = doc.data();
                        const masterID  = item.masterID;
                        const name      = item.name || "名称なし";
                        const schedules = item.schedule || {};
                        Object.entries(schedules).forEach(([category, schedule]) => {
                            let dateFields = [];
                            if (category === "others") {
                            // others の場合: 各フィールドに workingDate があるか確認
                            dateFields = Object.entries(schedule)
                                .filter(([, v]) => Array.isArray(v?.workingDate) && v.workingDate.length === 2)
                                .map(([fieldKey, v]) => ({
                                    fieldKey,
                                    range: v.workingDate
                                }));
                            } else {
                            if (Array.isArray(schedule.PlannedStartDate) && schedule.PlannedStartDate.length === 2) {
                                dateFields = [{ fieldKey: "PlannedStartDate", range: schedule.PlannedStartDate }];
                            }
                            }
                        
                            dateFields.forEach(({ fieldKey, range }) => {
                                const [startStr, endStrRaw] = range;
                                if (!startStr || !endStrRaw) return;
                            
                                const start = new Date(startStr);
                                let end = new Date(endStrRaw);
                            
                                const oneDayMs = 24 * 60 * 60 * 1000;
                                if (end.getTime() - start.getTime() <= oneDayMs) {
                                    end = new Date(end.getTime() + oneDayMs);
                                }
                                const correctedEndStr = end.toISOString().split("T")[0];
                                // const status = schedule.EndDate ? "completed" : "incomplete";
                                let isCompleted = false;
                                if (category === "others") {
                                    const fieldData = schedule?.[fieldKey];  // 例: schedule.others.点検A など
                                    isCompleted =
                                        fieldData?.EndDate?.reporter &&
                                        fieldData?.EndDate?.reporter.trim() !== "" &&
                                        fieldData?.EndDate?.reportDate &&
                                        fieldData?.EndDate?.reportDate.trim() !== "";
                                } else {
                                    isCompleted =
                                        schedule?.EndDate?.reporter &&
                                        schedule?.EndDate?.reporter.trim() !== "" &&
                                        schedule?.EndDate?.reportDate &&
                                        schedule?.EndDate?.reportDate.trim() !== "";
                                }

                                const status = isCompleted ? "completed" : "incomplete";




                            
                                // ★★★ 本日の日付と比較して超過かどうか判定 ★★★
                                const today = new Date();
                                today.setHours(today.getHours() + 9, 0, 0, 0); // UTC → JST に変換（+9時間）
                                const endDate = new Date(endStrRaw);
                                endDate.setHours(endDate.getHours() + 9, 0, 0, 0); // UTC → JST
                            
                                const isOverdue = endDate < today && (!status || status === "incomplete");
                            
                                allTasks.push({
                                    id:           `${doc.id}-${category}-${fieldKey}`,
                                    name,
                                    start:        startStr,
                                    end:          correctedEndStr,
                                    progress:     100,
                                    dependencies: "",
                                    custom_class: `bar-${category}${isOverdue ? '_overdue' : ''}${status === 'completed' ? '_completed' : '_incomplete'}`,
                                    requested:    startStr,
                                    category,
                                    fieldKey,
                                    masterID,
                                    status,
                                });
                            });
                            
                            
                        });
                    });
                } catch (error) {
                    console.error("Firestore取得エラー:", error);
                }
            }

            setTasks(allTasks);
        };

        fetchData();
    }, [selectedAndChildIDList]);

    useEffect(() => {
        const now = new Date();
        let rangeStart = new Date(now);
        let rangeEnd = new Date(now);
    
        switch (selectedFilter) {
            case "three-days-ago":
                rangeStart.setDate(now.getDate() - 3);
                break;
            case "yesterday":
                rangeStart.setDate(now.getDate() - 1);
                break;
            case "today":
                break;
            case "tomorrow":
                rangeStart.setDate(now.getDate() + 1);
                rangeEnd.setDate(now.getDate() + 1);
                break;
            case "three-days":
                rangeEnd.setDate(now.getDate() + 2);
                break;
            case "seven-days":
                rangeEnd.setDate(now.getDate() + 6);
                break;
            case "fourteen-days":
                rangeEnd.setDate(now.getDate() + 13);
                break;
            default:
                rangeStart = new Date("2000-01-01");
                rangeEnd = new Date("2100-01-01");
        }
    
        const activeUtilityKeys = Object.entries(selectedFilters)
            .filter(([_, isActive]) => isActive)
            .map(([key]) => key);
        
        const filtered = tasks.filter((task) => {
            const startDate = new Date(task.start);
            const endDate = new Date(task.end); // 表示用
            const isUtilityMatch = activeUtilityKeys.includes(task.category);
            const isDateMatch =
                (startDate >= rangeStart && startDate <= rangeEnd) ||
                (endDate >= rangeStart && endDate <= rangeEnd) ||
                (startDate <= rangeStart && endDate >= rangeEnd);
    
            const isCompleted = (task) => task.status === "completed";
            const isIncomplete = (task) => task.status === "incomplete";
                
            const isCompletionStatusMatch =
                completionStatus === "all" ||
                (completionStatus === "completed" && isCompleted(task)) ||
                (completionStatus === "incomplete" && isIncomplete(task));
    
            // デバッグログ
            // console.log(`--- task.id: ${task.id}`);
            // console.log(`task.start: ${task.start}`);
            // console.log(`task.end (表示用): ${task.end}`);
            // console.log(`task.completionEnd (判定用): ${task.completionEnd}`);
            // console.log(`completionStatus: ${completionStatus}`);
            // console.log(`isCompleted: ${isCompleted(task)}`);
            // console.log(`isCompletionStatusMatch: ${isCompletionStatusMatch}`);
            // console.log(`isUtilityMatch: ${isUtilityMatch}`);
            // console.log(`isDateMatch: ${isDateMatch}`);
    
            return isUtilityMatch && isDateMatch && isCompletionStatusMatch;
        });
    
        setFilteredTasks(filtered);
    }, [tasks, selectedFilters, selectedFilter, completionStatus]);
    
    
    

    // 完了・未完了のフィルター条件付与

    const completionFilteredTasks = filteredTasks.filter((task) => {
        const isCompleted = !!task.end;
        return (
          completionStatus === "all" ||
          (completionStatus === "completed" && isCompleted) ||
          (completionStatus === "incomplete" && !isCompleted)
        );
      });
      

    // barの条件付与
    useEffect(() => {
        if (!ganttRef.current) return;
        ganttRef.current.innerHTML = "";
      
        if (filteredTasks.length === 0) return;
      
        const gantt = new Gantt(ganttRef.current, filteredTasks, {
          view_mode: 'Day',
          date_format: 'YYYY-MM-DD',
          language: 'ja',
          on_click: (task)=>{
            handleBarClick(task);
          },
          custom_popup_html: (task) => `
            <div class='custom-popup'>
                <h5>${task.name}</h5>
                <p>作業名: ${task.fieldKey}</p>
                <p>カテゴリ: ${task.category}</p>
                <p>masterID: ${task.masterID}</p>
                <p>開始: ${task.requested}</p>
                <p>終了: ${task.end}</p>
            </div>
            `

        });
      
        // 少し遅らせてスクロールさせる（描画完了を待つ）
        setTimeout(() => {
          const svg = ganttRef.current.querySelector('svg');
          if (!svg) {
            console.log("svg が存在しません");
            return;
          }
      
          const ganttContainer = ganttRef.current.querySelector('.gantt');
          console.log('ganttContainerWidth', ganttContainer.width.animVal.value)
          const todayDiv = document.querySelector('.current-highlight');
          if (todayDiv) {
            const leftStyle = todayDiv.style.left; // e.g., "1752.75px"
            const todayX = parseFloat(leftStyle);  // 1752.75
            console.log("Today X position:", todayX);
      
            // ガントチャートの中心の座標を取得
            const centerX = ganttContainer.x.animVal.value + ganttContainer.width.animVal.value / 2;
            const centerY = ganttContainer.y.animVal.value + ganttContainer.height.animVal.value / 2;
            console.log("ガントチャートの中心:", centerX, centerY);
      
            // 今日の日付のX座標を取得
            const todayDivRect = todayDiv.style.left;
            console.log("今日の日付のX座標:", todayDivRect);
      
            // 今日の日付を中心に表示する
            const todayXPos = centerX + (todayX - centerX);
            console.log("今日の日付のX位置:", todayXPos);
      
            // .current-highlight クラス名を持つ要素が存在するかどうかを確認する
            const currentHighlight = ganttRef.current.querySelector('.current-highlight');
            if (currentHighlight) {
            //   currentHighlight.setAttribute('transform', `translate(${todayXPos}, ${centerY})`);
            //   currentHighlight.setAttribute('transform', `translate(${centerX}, ${centerY})`);
              currentHighlight.setAttribute('transform', `translate(10000000, 0)`);
            } else {
              console.log("。current-highlight クラス名を持つ要素が存在しません");
            }
          }
        }, 100); // 100msくらい待つと描画が安定する
      }, [filteredTasks]);

    useEffect(() => {
        if (selectedNode?.type === "false") {
            setIsActionButtonDisabled(false);
        } else {
            setIsActionButtonDisabled(true);
        }
    }, [selectedNode]);

    const handleEditButtonClick = () => {
        if (selectedID) {
            navigate(`/EditMaster/${selectedID.split('master_')[1]}`);
        }
    };

    const handleCreateButtonClick = () => {
        navigate("/CreateMaster");
    };

    const toggleFilter = (filterKey) => {
        setSelectedFilters((prevFilters) => ({
            ...prevFilters,
            [filterKey]: !prevFilters[filterKey]
        }));
    };

    const handleBarClick = (task) => {
        // console.log("クリックされたバー:", task);
        setSelectedRow(task);
        setIsActionButtonDisabled(false);  // 編集ボタンを有効にしたい場合など
    };
    

    const handleEditClick = () => {
        if (selectedRow) {
            navigate(`/EditMaster/${selectedRow.masterID}`, { state: { edit: true, data: selectedRow } });
        }
    };
    const handleScrollLeft = () => {
        console.log('left')
    };
    const handleScrollRight = () => {
        console.log('right')
    };

    
    const GanttChart = ({ tasks }) => {
        const ganttRef = useRef(null);
        useEffect(() => {
            if (ganttRef.current) {
            const gantt = new Gantt(ganttRef.current, tasks, {
                view_mode: 'Day',
                date_format: 'YYYY-MM-DD',
                custom_popup_html: null,
            });
            const container = ganttRef.current;
            const header = container.querySelector('.grid-header');
            const handleScroll = (e) => {
                const scrollLeft = e.target.scrollLeft;
                if (header) {
                header.style.transform = `translateX(-${scrollLeft}px)`;
                }
            };
            container.addEventListener('scroll', handleScroll);
            // クリーンアップ
            return () => {
                container.removeEventListener('scroll', handleScroll);
            };
            }
        }, [tasks]);
    return ;
    };




    return (
        <div className="main-container">
            <div className="leftContainer">
                {/* <div className="buttonArea">
                    <button onClick={handleCreateButtonClick} className="create-button">
                        <FontAwesomeIcon icon={faSquarePlus} />
                        新規作成
                    </button>
                    <button onClick={handleEditButtonClick} className="edit-button" disabled={isActionButtonDisabled}>
                        <FontAwesomeIcon icon={faPencil}/>
                        編集
                    </button>
                </div> */}
                <TreeView className="treeview-area" />
            </div>
            <div className="rightContainer">
                <div className="gantt-header">
                    {/* フィルターエリア */}
                    <div className="filter-area">
                        {/* カテゴリーフィルターボタン */}
                        <div className="filter-group group-category">
                            {utilityCollections.map(({ filterKey, displayName }) => (
                            <button
                                key={filterKey}
                                className={`filter-button utility ${filterKey} ${selectedFilters[filterKey] ? "active" : ""}`}
                                onClick={() => toggleFilter(filterKey)}
                            >
                                {displayName}
                            </button>
                            ))}
                        </div>

                        {/* 日付フィルターボタン */}
                        <div className="filter-group group-date">
                            {dateCollections.map(({ filterKey, displayName, colorClass }) => (
                            <button
                                key={filterKey}
                                className={`filter-button ${colorClass} ${selectedFilter === filterKey ? "active" : ""}`}
                                onClick={() => setSelectedFilter(filterKey)}
                            >
                                {displayName}
                            </button>
                            ))}
                        </div>

                        {/* 完了・未完了のフィルターボタン */}
                        <div className="filter-group group-completion">
                            {["all", "completed", "incomplete"].map((status) => (
                            <button
                                key={status}
                                onClick={() => setCompletionStatus(status)}
                                className={`filter-button ${completionStatus === status ? "active" : ""}`}
                            >
                                {status === "all" ? "すべて" : status === "completed" ? "完了" : "未完了"}
                            </button>
                            ))}
                        </div>
                    </div>

                    <div className="button-area">
                        <button
                            className="edit-button"
                            onClick={handleEditClick}
                            disabled={!selectedRow}
                        >
                            編集
                        </button>
                        {/* 右・左へ移動させるボタン */}
                        {/* <button
                            className="scroll-button left"
                            onClick={handleScrollLeft}
                        >
                            <FontAwesomeIcon icon={faLeftLong} />
                        </button>
                        <button
                            className="scroll-button right"
                            onClick={handleScrollRight}
                        >
                            <FontAwesomeIcon icon={faRightLong} />
                        </button> */}

                    </div>
                </div>
                {tasks.length> 0 ?(
                    <div className="gantt-area" ref={ganttRef}></div>
                ):(
                    <div className="message-area">表示できるデータがありません</div>
                )}
                
            </div>
        </div>
    );
};

const GanttPage = () => (
    <TreeViewProvider>
        <GanttContent />
    </TreeViewProvider>
);

export default GanttPage;
